module.exports = __webpack_public_path__ + "img/87.6.CODm.5bd521b1.png";